<template>
  <div>
    <article class="con2">
      <div class="container">
        <p>체계적인 학습 관리</p>
        <p>당근 중국어만의<br />4단계 완전학습 시스템</p>
        <ul>
          <li>
            <div class="img-box">
              <img
                src="@/assets/img/chinese/index/con2/item1-pc.png"
                alt="img"
                class="img-pc"
              />
              <img
                src="@/assets/img/chinese/index/con2/item1-m.png"
                alt="img"
                class="img-m"
              />
            </div>
            <div class="text-box">
              <p>STEP 01</p>
              <p>사전학습</p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item1-icon.png"
                    alt="icon"
                  />
                  <p><span>어휘 및 구문 학습</span>으로 주요표현 암기</p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item1-icon.png"
                    alt="icon"
                  />
                  <p><span>문장 구성학습</span>을 통해 Key Expression 체득화</p>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div class="img-box">
              <img
                src="@/assets/img/chinese/index/con2/item2-pc.png"
                alt="img"
                class="img-pc"
              />
              <img
                src="@/assets/img/chinese/index/con2/item2-m.png"
                alt="img"
                class="img-m"
              />
            </div>
            <div class="text-box">
              <p>STEP 02</p>
              <p>정규수업</p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item2-icon.png"
                    alt="icon"
                  />
                  <p>원어민 강사님의 <span>전화 화상 수업</span></p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item2-icon.png"
                    alt="icon"
                  />
                  <p><span>1:1 개인별 맞춤 수업</span> 진행</p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item2-icon.png"
                    alt="icon"
                  />
                  <p>
                    <span>발음, 제스처, 표정</span>을 보며 재미도 두배, 학습도
                    두배!
                  </p>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div class="img-box">
              <img
                src="@/assets/img/chinese/index/con2/item3-pc.png"
                alt="img"
                class="img-pc"
              />
              <img
                src="@/assets/img/chinese/index/con2/item3-m.png"
                alt="img"
                class="img-m"
              />
            </div>
            <div class="text-box">
              <p>STEP 03</p>
              <p>피드백&복습</p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item3-icon.png"
                    alt="icon"
                  />
                  <p>담임강사님의 <span>교정 피드백</span></p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item3-icon.png"
                    alt="icon"
                  />
                  <p><span>수업 녹취⋅녹화파일</span>로 복습까지!</p>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <div class="img-box">
              <img
                src="@/assets/img/chinese/index/con2/item4-pc.png"
                alt="img"
                class="img-pc"
              />
              <img
                src="@/assets/img/chinese/index/con2/item4-m.png"
                alt="img"
                class="img-m"
              />
            </div>
            <div class="text-box">
              <p>STEP 04</p>
              <p>초과학습</p>
              <ul>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item4-icon.png"
                    alt="icon"
                  />
                  <p>수업내용과 연계된 <span>동영상 강좌</span>로 초과학습</p>
                </li>
                <li>
                  <img
                    src="@/assets/img/chinese/index/con2/item4-icon.png"
                    alt="icon"
                  />
                  <p>
                    <span>문법과 어휘, 퀴즈학습</span>으로 완벽하게 학습 마무리
                  </p>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </article>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: calc(100% - 40px);
  margin: 0 auto;

  @media screen and (min-width: 1050px) {
    max-width: 1000px;
  }
}

.con2 {
  padding: 85px 0;
  background-color: #f9fafb;

  @media screen and (min-width: 1050px) {
    padding: 160px 0;
  }

  .container {
    > p {
      text-align: center;

      @media screen and (min-width: 1050px) {
        text-align: left;
      }

      &:nth-of-type(1) {
        font-size: 16px;
        font-weight: 700;
        color: #7b53eb;
        margin-bottom: 16px;

        @media screen and (min-width: 1050px) {
          font-size: 28px;
          margin-bottom: 44px;
        }
      }

      &:nth-of-type(2) {
        font-size: 30px;
        font-weight: 700;
        color: #09090b;
        margin-bottom: 37px;

        @media screen and (min-width: 1050px) {
          font-size: 50px;
          margin-bottom: 114px;
        }
      }
    }

    > ul {
      display: flex;
      flex-direction: column;
      gap: 35px;

      @media screen and (min-width: 1050px) {
        gap: 80px;
      }

      > li {
        display: flex;
        flex-direction: column-reverse;
        gap: 35px;
        padding: 45px 28px;
        border-radius: 28px;

        @media screen and (min-width: 1050px) {
          flex-direction: row;
          align-items: center;
          gap: 57px;
          padding: 72px 110px;
          border-radius: 42px;
        }

        &:nth-of-type(1) {
          background-color: #e5e7eb;

          .text-box {
            > p {
              &:nth-of-type(1) {
                color: #6b7280;
              }
            }
          }
        }

        &:nth-of-type(2) {
          background-color: #f1edfd;

          .text-box {
            > p {
              &:nth-of-type(1) {
                color: #7b53eb;
              }
            }
          }
        }

        &:nth-of-type(3) {
          background-color: #ffeaf1;

          .text-box {
            > p {
              &:nth-of-type(1) {
                color: #ff3378;
              }
            }
          }
        }

        &:nth-of-type(4) {
          background-color: #ebf2fe;

          .text-box {
            > p {
              &:nth-of-type(1) {
                color: #3b82f6;
              }
            }
          }
        }

        .img-box {
          padding: 25px;
          background-color: #ffffff;
          border-radius: 20px;

          @media screen and (min-width: 1050px) {
            padding: 30px;
            max-width: 350px;
          }

          .img-pc {
            display: none;
            @media screen and (min-width: 1050px) {
              display: block;
            }
          }

          .img-m {
            @media screen and (min-width: 1050px) {
              display: none;
            }
          }
        }

        .text-box {
          > p {
            &:nth-of-type(1) {
              font-size: 15px;
              font-weight: 700;
              margin-bottom: 6px;

              @media screen and (min-width: 1050px) {
                font-size: 22px;
                margin-bottom: 10px;
              }
            }
            &:nth-of-type(2) {
              font-size: 25px;
              font-weight: 700;
              color: #09090b;
              margin-bottom: 13px;

              @media screen and (min-width: 1050px) {
                font-size: 35px;
                margin-bottom: 48px;
              }
            }
          }

          ul {
            display: flex;
            flex-direction: column;
            gap: 9px;

            @media screen and (min-width: 1050px) {
              gap: 12px;
            }

            li {
              display: flex;
              align-items: center;
              gap: 8px;

              img {
                width: 15px;

                @media screen and (min-width: 1050px) {
                  width: 18px;
                }
              }

              p {
                font-size: 14px;
                color: #374151;

                @media screen and (min-width: 1050px) {
                  font-size: 18px;
                }

                span {
                  font-weight: 700;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
